const SECOND = 1000;
const MINUTE = 60 * SECOND;
export const ACCUMULATE_DATA_TIMEOUT = 5 * MINUTE;
export const INTERVALS = [3 * MINUTE, 7 * MINUTE, 15 * MINUTE];
export const TALK_RATES = {
    DISCOVERY: 'discovery',
    DEFAULT: 'default',
    DEMO: 'demo'
};
export const TALK_RATE_ITEMS = [
    {
        slug: TALK_RATES.DISCOVERY,
        nameKey: 'speakerStats.talkRates.discovery',
        ratio: 40
    },
    {
        slug: TALK_RATES.DEFAULT,
        nameKey: 'speakerStats.talkRates.default',
        ratio: 60
    },
    {
        slug: TALK_RATES.DEMO,
        nameKey: 'speakerStats.talkRates.demo',
        ratio: 80
    }
];
export const ANALYTIC_HINTS_MESSAGE = {
    hints: 'hints settings changed',
    speakerStats: 'speaker stats opened'
};
